import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { inject, provideAppInitializer } from '@angular/core';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { authInterceptor } from './app/core/interceptors/auth.interceptor';
import { errorInterceptor } from './app/core/interceptors/error.interceptor';
import { SettingsService } from './app/core/services/settings.service';
import { AuthStateService } from './app/core/services/auth-state.service';
import { AuthService } from './app/features/auth/services/auth.service';

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular({ innerHTMLTemplatesEnabled: true }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(
      withInterceptors([errorInterceptor, authInterceptor]),
    ),
    provideAppInitializer(async () => {
      // Apply saved theme/typography before first paint.
      inject(SettingsService);

      // Refresh the profile on every app open (not just when there's no cached
      // copy) so permission flags like `can_debug` are never stale from a prior
      // session. `silent: true` is essential here: it skips the global
      // forced-logout-on-401 (see error.interceptor.ts) so a failure (offline,
      // expired token, server restart) never logs a user out just for opening
      // the app with perfectly valid local/cached data — this app's native
      // draft storage is built to keep working offline. `.catch` is a further
      // backstop so bootstrap itself is never blocked either way.
      const authState = inject(AuthStateService);
      const authService = inject(AuthService);
      if (authState.isAuthenticated()) {
        await authService.fetchProfile({ silent: true }).catch(() => {});
      }
    }),
  ],
});
